export const NOT_RUSSIA_MESSAGE = 'Не похоже на Россию';

// Грубые границы: отсекаем явные ошибки (Австралия, Аргентина), но гарантированно покрываем всю Россию.
// Долгота: от Калининграда (~19.6) на восток через 180° до Чукотки (~-169).
const MIN_LATITUDE = 41;
const MAX_LATITUDE = 82;
const WEST_LONGITUDE = 19;
const EAST_LONGITUDE_AFTER_ANTIMERIDIAN = -168;

export const isLikelyInRussia = (latitude: number, longitude: number): boolean =>
  latitude >= MIN_LATITUDE && latitude <= MAX_LATITUDE && (longitude >= WEST_LONGITUDE || longitude <= EAST_LONGITUDE_AFTER_ANTIMERIDIAN) && longitude >= -180 && longitude <= 180;

/** Возвращает текст ошибки или null, если координаты корректны (обе пустые тоже корректны). */
export const validateCoordinates = (latitude: number | null | undefined, longitude: number | null | undefined): string | null => {
  const hasLat = latitude !== null && latitude !== undefined;
  const hasLon = longitude !== null && longitude !== undefined;

  if (!hasLat && !hasLon) return null;
  if (hasLat !== hasLon) return 'Нужно указать и широту, и долготу';
  if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return 'Координаты должны быть числами';
  if (!isLikelyInRussia(latitude as number, longitude as number)) return NOT_RUSSIA_MESSAGE;

  return null;
};
